
export type GetApiCoursesStatus = typeof GetApiCoursesStatus[keyof typeof GetApiCoursesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCoursesStatus = {
  'in-progress': 'in-progress',
  completed: 'completed',
} as const;
